// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__p308K","gfeWrapper":"CalendarEvent_gfeWrapper__16fib"};